/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import "simplebar";
import "simplebar/dist/simplebar.min.css";

import Swiper from "swiper/bundle";
import "swiper/swiper-bundle.css";

const homeSwiper = new Swiper ('.home_swiper', {
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    speed: 1500,
    autoplay: {
        delay: 4000,
    }
    // pagination: {
    //     el: '.pagination1',
    //     clickable: true,
    // },
});
const homePdSwiper = new Swiper ('.pd_swiper', {
    speed: 1500,
    slidesPerView : 1,
    spaceBetween : 10,
    centeredSlides : true,
    // loop : true,
    navigation: {
        nextEl: '.pd_swiper_next',
        prevEl: '.pd_swiper_prev',
    },
    breakpoints: { 
        768: {  //当屏幕宽度大于等于768 
            slidesPerView: 2,
            spaceBetween: 10
        }
    }
});

const newsSwiper = new Swiper ('.news_swiper', {
    speed: 1500,
    slidesPerView : 1,
    spaceBetween : 30,
    navigation: {
        nextEl: '.news_next_btn',
        prevEl: '.news_prev_btn',
    },
    breakpoints: { 
        768: {  //当屏幕宽度大于等于768 
            slidesPerView: 2,
            spaceBetween: 20
    },
        1280: {  //当屏幕宽度大于等于1280
            slidesPerView: 2.5,
            spaceBetween: 30
        }
    }
});

var homeGallerySwiper = new Swiper ('.gallery_swiper', {
    speed: 1500,
    slidesPerView : 1,
    spaceBetween : 30,
    pagination: {
        el: '.pagination_gallery',
        clickable: true,
    },
    breakpoints: { 

        768: {  //当屏幕宽度大于等于768 
            slidesPerView: 2,
            spaceBetween: 20
    },
        1280: {  //当屏幕宽度大于等于1280
            slidesPerView: 3,
            spaceBetween: 30
        }
    }
});

const pdSwiperThumbs = new Swiper('.pdshow_swiper_thumbs',{
    spaceBetween: 30,
    slidesPerView: 4,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    centerInsufficientSlides: true,
    slideToClickedSlide: true
})

const pdSwiper = new Swiper ('.pdshow_swiper', {
    spaceBetween: 10,
    thumbs: {
        swiper: pdSwiperThumbs
    },
    on: {
        slideChange: function () {
            let activeIndex = this.activeIndex + 1;
            let activeSlide = document.querySelector(`.gallery-thumbs .swiper-slide:nth-child(${activeIndex})`);
            let nextSlide = document.querySelector(`.gallery-thumbs .swiper-slide:nth-child(${activeIndex + 1})`);
            let prevSlide = document.querySelector(`.gallery-thumbs .swiper-slide:nth-child(${activeIndex - 1})`);  
            if (nextSlide && !nextSlide.classList.contains('swiper-slide-visible')) {
                this.thumbs.swiper.slideNext()    
            } else if (prevSlide && !prevSlide.classList.contains('swiper-slide-visible')) {
              this.thumbs.swiper.slidePrev()    
            }
        }
    }
});

var mySwiper6 = new Swiper ('.accessories_swiper', {
    speed: 1500,
    slidesPerView : 1,
    spaceBetween : 30,
    pagination: {
        el: '.pagination2',
        clickable: true,
    },
    breakpoints: { 
        768: {  //当屏幕宽度大于等于768 
            slidesPerView: 2,
            spaceBetween: 30
    },
        1280: {  //当屏幕宽度大于等于1280
            slidesPerView: 3,
            spaceBetween: 30
        }
    }
});

var mySwiper7 = new Swiper ('.fancy_swiper', {
    speed: 1500,
    slidesPerView : 1,
    navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
    breakpoints: { 
        768: {  //当屏幕宽度大于等于768 
            slidesPerView: 2,
            spaceBetween: 30
    },
        1280: {  //当屏幕宽度大于等于1280
            slidesPerView: 3,
            spaceBetween: 30
        }
    }
});

var mySwiper8 = new Swiper ('.pd_acc_swiper', {
    speed: 1500,
    slidesPerView : 2,
    pagination: {
        el: '.pagination3',
        clickable: true,
    },
    breakpoints: { 
        768: {  //当屏幕宽度大于等于768 
            slidesPerView: 3,
            spaceBetween: 30
    },
        1280: {  //当屏幕宽度大于等于1280
            slidesPerView: 4,
            spaceBetween: 30
        }
    }
});

const accSwiperThumbs = new Swiper('.acc_swiper_thumbs', {
    spaceBetween: 10,
    slidesPerView: 4,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    centerInsufficientSlides: true,
    slideToClickedSlide: true
});

const accSwiper = new Swiper('.acc_swiper', {
    spaceBetween: 10,
    thumbs: {
        swiper: accSwiperThumbs
    },
    on: {
        slideChange: function () {
            let activeIndex = this.activeIndex + 1;
            let activeSlide = document.querySelector(`.gallery-thumbs .swiper-slide:nth-child(${activeIndex})`);
            let nextSlide = document.querySelector(`.gallery-thumbs .swiper-slide:nth-child(${activeIndex + 1})`);
            let prevSlide = document.querySelector(`.gallery-thumbs .swiper-slide:nth-child(${activeIndex - 1})`);  
            if (nextSlide && !nextSlide.classList.contains('swiper-slide-visible')) {
                this.thumbs.swiper.slideNext()    
            } else if (prevSlide && !prevSlide.classList.contains('swiper-slide-visible')) {
              this.thumbs.swiper.slidePrev()    
            }
        }
    }
});